module.exports = __webpack_public_path__ + "img/explain-in-detail.d708cf2f.png";